export const BaseUrl =
  process.env.REACT_APP_BASE_URL ||
  "https://api.pactocoin.com/admin-svc/api/v1/";
